export type ServiceSegment = 'CUE' | 'AGENT';
export type ServiceBarActiveService = ServiceSegment | null;

export const SERVICE_SEGMENT_LABEL: Record<ServiceSegment, string> = {
    CUE: 'Cue',
    AGENT: 'Agent',
};

export type ServiceMoreMenuGateInput = {
    subscriptionStatus?: string | null;
    hasClmLicense?: boolean;
    hasElmLicense?: boolean;
};

export type ElmServiceEntryPolicyInput = {
    subscriptionStatus?: string | null;
    isClmLite?: boolean | null;
};

export type ServiceMoreMenuItemId = 'CUE' | 'AGENT' | 'LEGAL_AGENT' | 'CLM' | 'CLM_LITE' | 'ELM';

export const SERVICE_MORE_MENU_ITEM_LABEL = {
    CUE: 'Cue',
    AGENT: 'Agent',
    LEGAL_AGENT: 'Agent',
} as const satisfies Pick<Record<ServiceMoreMenuItemId, string>, 'CUE' | 'AGENT' | 'LEGAL_AGENT'>;

export type ServiceMoreMenuItem = {
    id: ServiceMoreMenuItemId;
    href?: string;
    active?: boolean;
    disabled?: boolean;
    target?: string;
    rel?: string;
    dataPhEvent?: string;
};

const CONTRACT_AGENT_ACTIVE_PRODUCT_TYPES = new Set(['LEGAL_AGENT', 'CLM', 'CLM_LITE', 'ELM']);

export function getContractLnbActiveService(serviceName?: string | null): ServiceBarActiveService {
    return serviceName && CONTRACT_AGENT_ACTIVE_PRODUCT_TYPES.has(serviceName) ? 'AGENT' : null;
}

export type ContractServiceEntryProduct = 'LEGAL_AGENT' | 'CLM' | 'ELM';

export type ContractServiceEntryPathInput = {
    entryProduct: ContractServiceEntryProduct;
    newChat?: number | string;
};

export const CONTRACT_SERVICE_ENTRY_PRODUCT_PARAM = 'entryProduct';
export const CONTRACT_SERVICE_ENTRY_NEW_CHAT_PARAM = 'newChat';

export function canShowServiceMoreMenu({ subscriptionStatus, hasClmLicense = false, hasElmLicense = false }: ServiceMoreMenuGateInput): boolean {
    return subscriptionStatus === 'ACTIVE' && (hasClmLicense || hasElmLicense);
}

export function shouldHideElmServiceEntry({ subscriptionStatus, isClmLite = false }: ElmServiceEntryPolicyInput): boolean {
    return subscriptionStatus === 'ACTIVE' && isClmLite === true;
}

export function buildLnbServiceUrl(serviceBaseUrl: string, path: string): string {
    return new URL(path, serviceBaseUrl).toString();
}

export function buildContractServiceEntryPath({ entryProduct, newChat }: ContractServiceEntryPathInput): string {
    const searchParams = new URLSearchParams();
    searchParams.set(CONTRACT_SERVICE_ENTRY_PRODUCT_PARAM, entryProduct);

    if (newChat !== undefined) {
        searchParams.set(CONTRACT_SERVICE_ENTRY_NEW_CHAT_PARAM, String(newChat));
    }

    return `/?${searchParams.toString()}`;
}
